import { LucideProps } from 'lucide-react';

/**
 * Map-pin swatch for an image legend — the plot mark on the Killwangen flood
 * map (WB-845). Vanesa's "location icon.svg" from MRKT-1139, not the outlined
 * lucide `map-pin`, because it has to read as the same filled pin drawn on the
 * map. See LegendBoxIcon for why the fill is hard-coded.
 */
export const LegendPinIcon = ({
  size = 20,
  className,
  ...props
}: LucideProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 33.91 47.99"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M33.89,15.41l.03,2.47c-.06.01-.1.13-.08.21.06.33-.03.59-.08.89-.22,1.28-.52,2.48-.97,3.7-.69,1.84-1.55,3.54-2.56,5.22-1.12,1.87-2.29,3.63-3.55,5.42-1.7,2.43-3.26,4.87-4.73,7.45l-3.52,6.17c-.21.38-.43.72-.79.96-.43.29-.95-.16-1.27-.73l-3.39-5.93c-1.42-2.48-2.95-4.81-4.56-7.18l-3.78-5.55c-1.3-1.91-2.34-3.91-3.2-6.05-.6-1.5-1.01-2.98-1.27-4.57-.04-.26-.14-.46-.07-.75.02-.1,0-.25-.08-.28v-2.56s.13-.83.13-.83c.22-1.6.72-3.05,1.38-4.53.88-1.97,2.13-3.64,3.8-5.01,2.03-1.66,4.39-2.78,6.95-3.38,1.96-.46,3.88-.66,5.87-.49,5.81.48,10.75,3.21,13.55,8.39,1.18,2.19,1.97,4.51,2.21,6.96Z"
      fill="#EF0165"
    />
  </svg>
);
